import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import employees, { employeesSaga } from './employees';
import employee, { employeeSaga } from './employee';
import employeeResume, { employeeResumeSaga } from './empResume';
import employeePersonal, { employeePersonalSaga } from './empPersonal';
import employeeHr, { employeeHrSaga } from './empHr';
import employeeApproval, { employeeApprovalSaga } from './empApproval';

const empModule = combineReducers({
  employee,
  employees,
  employeeResume,
  employeePersonal,
  employeeHr,
  employeeApproval
});

export function* empModuleSaga() {
  yield all([
    employeesSaga(),
    employeeSaga(),
    employeeResumeSaga(),
    employeePersonalSaga(),
    employeeHrSaga(),
    employeeApprovalSaga()
  ]);
}

export default empModule;
